import React, {useState, useEffect, useContext} from 'react';
import {EditorState, convertToRaw, convertFromRaw} from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import FloContext from "../contexts/floContext";

export default function ContentEditor(props: any) {
   const {step, readOnly, onFocus} = props;
   const {steps, onInstructionEdit}: any = useContext(FloContext);
   const [editorState, setEditorState] = useState(EditorState.createEmpty());
   const linkifyPlugin = createLinkifyPlugin({
      component(props) {
         return (
             <React.Fragment>
                <img src={'http://www.google.com/s2/favicons?domain=' + props.href} alt=""/>
                <a {...props} target="_blank" />
             </React.Fragment>
         );
      },
      target: '_blank'
   });
   const plugins = [linkifyPlugin];

   useEffect(() => {
      if (step && step.content) {
         setEditorState(EditorState.createWithContent(convertFromRaw(step.content)));
      } else {
         setEditorState(EditorState.createEmpty());
      }
   }, [steps])


   function onChange(editorState: any) {
      setEditorState(editorState);
   }

   function focus() {
      if (!readOnly) onFocus(step);
   }
   function updateInstruction() {
      if (!readOnly) onFocus({_id: null});
      onInstructionEdit(step, convertToRaw(editorState.getCurrentContent()));
   }


   return (
       <div>
          <Editor
              editorState={editorState}
              onChange={onChange}
              plugins={plugins}
              readOnly={readOnly}
              onBlur={updateInstruction}
              onFocus={focus}
          />
       </div>
   )


}
